import { Component, Input, OnInit } from '@angular/core';
import { SummaryDate } from '@shared/models/summary-date';
import Utils from '@shared/utils/utils';

@Component({
  selector: 'app-date-view',
  templateUrl: './date-view.component.html',
  styleUrls: ['./date-view.component.scss']
})
export class DateViewComponent implements OnInit {

  @Input() tabName: any;
  @Input() summaryDateData: SummaryDate[];

  constructor() {
  }

  @Input()
  set setSummaryDateData(value) {
    if (!Utils.isEmpty(value)) {
      this.summaryDateData = value;
    } else {
      this.summaryDateData = [];
    }
  }

  ngOnInit(): void {
  }
}
